/* lua.js generated code 0.3.0 */

var BottomButtonAnim = require("clover/panel/component/common/uiButtonAnims/HomeSceneBottomBtnAnim")
let HomeSceneButton = require("clover/scene/component/homescene/HomeSceneButton")
var FAQButtion = xClass("FAQButtion", HomeSceneButton)
//var FAQButtion = xClass("FAQButtion", cc.Node)
FAQButtion.prototype.ctor = function (type) {
    HomeSceneButton.prototype.ctor.call(this, "帮助·建议", "homeScene/faq_img.png")
    let self = this
    //cc.Node.prototype.ctor.call(self)
    self.type = type || 1
    //self.init()
}

FAQButtion.prototype.customInit = function () {
    var self = this
    self.btn.nodeExist = true
    self.isBusy = false
    if (self.imageNode != null){
        self.imageNode.x = 5
    }
    //BottomButtonAnim.create(self.btn)
}

FAQButtion.prototype.onCick = function (){
    this.onOpenFC()
}

/*FAQButtion.prototype.init = function () {
    let self = this
    self.node = cc.CSLoader.createNode("cocos/homeScene_friend2_btn.csb")
    self.addChild(self.node)
    self.node.setPositionY(self.node.getPositionY() + 20);
    let label = self.node.getChildByName("txt")
    label.setString("帮助·建议")
    label.setLocalZOrder(2)
    label.setScale(label.getScale() * 0.83) // 字太多，缩小点
    label.setPositionY(label.getPositionY() - 10)
    label.getVirtualRenderer().setAdditionalKerning(-3)
    self.node.getChildByName("bg").setScale(1)

    let newText = cc.LabelTTF.create('帮助', FONT_DEF.microsoftYahei_24_blueStroke)
    newText.setScale(0.83)
    newText.x = -1
    newText.y = -47
    label.removeFromParent(true)
    self.node.addChild(newText, 2, "txt")
    // let bg = self.node.getChildByName("bg")
    // bg.removeFromParent(true)
    let icon = self.node.getChildByName("icon")
    let FAQButtion = cc.Sprite.createWithSpriteFrameName("homeScene/faq_img.png")
    FAQButtion.setPosition(icon.getPosition())
    FAQButtion.setAnchorPoint(0.5, 0.8)
    // FAQButtion.setScale(0.625)
    icon.removeFromParent(true)
    self.node.addChild(FAQButtion, 1, "icon")
    let btn = UIButton.create(self.node, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenFC))
    self.btn = btn
    self.btn.nodeExist = true
    self.isBusy = false
    BottomButtonAnim.create(self.btn)
}*/
FAQButtion.prototype.onOpenFC = function () {
    var self = this
    self.btn.setEnabled(false)
    self.runAction(cc.Sequence.create(cc.DelayTime.create(2), cc.CallFunc.create(function () {
        if (self.btn.nodeExist) {
            self.btn.setEnabled(true)
        }
    })))
    function onFail() {
        Toast.make("打开帮助&建议错误，请重试！")
    }
    if (META.platform == XcloverPlatform.wechatgame) {
        if(mini.openCustomerServiceConversation) {
            mini.openCustomerServiceConversation();
        } else {
            if (window.qq) {
                Toast.make("QQ小程序暂不支持客服消息。");
            }else{
                Toast.make("您的App版本过低，请升级后重试");
            }
            // require("clover/panel/FcPanel").asyncCreate(function () {
            //     self.btn.setEnabled(true)
            // }, function () {
            //     Toast.make("网络出了点问题啦~", 2, function () {
            //         self.btn.setEnabled(true)
            //     })
            // }, function () {
            //     self.btn.setEnabled(true)
            // })
        }
    } else {
        switch (self.type) {
            case 1:
                OpenFunscareLogic.openFunscare(1, null, null, onFail)
                break;
            case 2:
                OpenFunscareLogic.openForum(0, null, null, onFail)
            default:
                break;
        }
    }
    DCAssist.dc4OpenModule(ModuleName.FAQ)
}
module.exports = FAQButtion
